import { useSearchParams } from 'react-router-dom';

export type ProjectTabs = 'allProjects' | 'pendingProjects';

/**
 * Hook to manage the activeTab URL parameter for the projects page.
 *
 * Usage:
 *   const { tabParam, setTabParam, getValidTab } = useProjectsTabParam();
 *
 *   // Navigate to pending projects tab
 *   setTabParam('pendingProjects');
 *
 *   // Get current tab from URL
 *   const currentTab = getValidTab(tabParam);
 */

export const useProjectsTabParam = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get('activeTab') as ProjectTabs | null;

  const setTabParam = (tab: ProjectTabs) => {
    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      newParams.set('activeTab', tab);
      return newParams;
    });
  };

  const deleteTabParam = () => {
    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      newParams.delete('activeTab');
      return newParams;
    });
  };

  const getValidTab = (tab: ProjectTabs | null): ProjectTabs => {
    if (tab === 'allProjects' || tab === 'pendingProjects') {
      return tab;
    }
    return 'allProjects';
  };

  return {
    tabParam,
    setTabParam,
    deleteTabParam,
    getValidTab,
  };
};
